import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
});

// Системные пути требующие авторизации
const PRIVATE_PATHS = [
  '/dashboard', '/become-specialist', '/profile',
  '/bookings', '/favorites', '/notifications', '/settings',
  '/admin',
];

const isPrivatePath = (pathname: string): boolean => {
  return PRIVATE_PATHS.some(p => pathname === p || pathname.startsWith(p + '/'));
};



api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await axios.post(
          `${process.env.NEXT_PUBLIC_API_URL}/auth/refresh`,
          {},
          { withCredentials: true }
        );
        return api(originalRequest);
      } catch {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('user');
          // Редиректим на login ТОЛЬКО если страница приватная
          if (isPrivatePath(window.location.pathname)) {
            window.location.href = '/login';
          }
        }
      }
    }
    // Автоблок или блокировка аккаунта — разлогиниваем и редиректим
    const errCode = error.response?.data?.error?.code;
    if (error.response?.status === 403 && (errCode === 'ACCOUNT_BLOCKED' || errCode === 'WORD_FILTER_BLOCK')) {
      if (typeof window !== "undefined") {
        try {
          await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/auth/logout`, {}, { withCredentials: true });
        } catch {}
        localStorage.removeItem('user');
        window.location.href = '/login?blocked=1';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
